import "./index.scss";
import CustomModal from "../../components/common/modal";
import Button from "../../components/common/button";
import Checkbox from "../../components/common/FormFields/checkbox";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";

function RedirectAlertModal({ show, onClose, onConfirm }) {
  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    reset,
  } = useForm({
    mode: "onChange",
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <CustomModal show={show} handleClose={onClose}>
      <Form onSubmit={handleSubmit(() => onConfirm())}>
        <div className="redirect-modal-body">
          By selecting an insurance plan, you will be redirected to PolicyEra
          Insurance Broking Pvt. Ltd.. Please review the{" "}
          <strong>Terms & Conditions</strong> for more details.
        </div>
        <p>PolicyEra Insurance Broking Pvt. Ltd. is an IRDAI-registered insurance broker, facilitating these plans through partnerships with various insurance companies</p>
        <p>All queries, issues, or concerns related to purchased insurance plans and services will be exclusively managed by the PolicyEra Insurance Broking Team</p>
        {/* <div>
          <Checkbox
            rules={{
              required: true,
            }}
            name="statement1"
            className="checkbox-style"
            control={control}
            errors={errors}
            options={[
              {
                name: "statement1",
                label:
                  "PolicyEra Insurance Broking Pvt. Ltd. is an IRDAI-registered insurance broker, facilitating these plans through partnerships with various insurance companies",
              },
            ]}
          />
          <Checkbox
            rules={{
              required: true,
            }}
            name="statement2"
            className="checkbox-style"
            control={control}
            errors={errors}
            options={[
              {
                name: "statement2",
                label:
                  "All queries, issues, or concerns related to purchased insurance plans and services will be exclusively managed by the PolicyEra Insurance Broking Team",
              },
            ]}
          />
        </div> */}
        <div className="logout-modal-footer">
          <Button variant="secondary" onClick={handleClose} label="No" />
          <Button
            type="submit"
            variant="primary"
            // onClick={handleSubmit(onSubmit)}
            label="Yes"
          />
        </div>
      </Form>
    </CustomModal>
  );
}

export default RedirectAlertModal;
